import * as React from "react";
import { EditorState } from 'draft-js';
import { convertFromRaw, convertToRaw } from 'draft-js';
import { debounce } from '../../helpers/debounce';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export interface InlineTextEditProps { 
    source: string;
    onChange: Function;
}

// https://jpuri.github.io/react-draft-wysiwyg
// https://draftjs.org/docs/api-reference-editor-state

export default class InlineTextEdit extends React.PureComponent<InlineTextEditProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty()
        };
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.updateEditorState = this.updateEditorState.bind(this);
    }

    componentDidMount() {
        this.updateEditorState();
    }

    componentDidUpdate(prevProps) {
        // only update once
        if (this.props.source != prevProps.source && (!prevProps.source || prevProps.source == "")) {
            this.updateEditorState();
        }
    }

    updateEditorState() {
        if (this.props.source == "") {
            this.setState({
                editorState: EditorState.createEmpty(),
            });
        } else {
            try {
                let editorState = EditorState.createWithContent( convertFromRaw(JSON.parse(this.props.source)));
                this.setState({
                    editorState
                });
            } catch (error) {
                this.setState({
                    editorState: EditorState.createEmpty(),
                });
                console.error(error);
            }
        }
    }

    debounceChanges = debounce(this.onUpdate, 500, false);

    onEditorStateChange(editorState: any) {
        var self = this;
        this.setState({
            editorState,
        }, () => {
            self.debounceChanges();
        });
    }

    onUpdate() {
        let raw = convertToRaw(this.state.editorState.getCurrentContent());
        let json = JSON.stringify(raw);
        this.props.onChange(json);
    }

    render() {

        return (
            <div style={{ minHeight: '150px' }}>
                <Editor
                    editorState={this.state.editorState}
                    toolbarClassName="editor-text-display-toolbar"
                    wrapperClassName="editor-text-display-wrapper"
                    editorClassName="editor-text-display-editor"
                    onEditorStateChange={this.onEditorStateChange}
                    toolbar={{ 
                        options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'remove', 'history']
                    }}
                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Controls/InlineTextEdit.tsx